module.exports = __webpack_public_path__ + "static/media/cancel_filled_small.1ffbd2c6.svg";